import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import dayjs from 'utils/day';
import EN from './locales/en';
import FR from './locales/fr';

i18n
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // initialize with options
  .init({
    fallbackLng: 'en',
    debug:
      process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test',

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    ns: ['glossary', 'validation', 'sentences'],
    defaultNS: 'glossary',

    saveMissing: true,
    returnEmptyString: false,
    returnNull: false,

    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'span'],
    },

    resources: {
      en: {
        glossary: EN.glossary,
        sentences: EN.sentences,
        validation: EN.validation,
      },
      fr: {
        glossary: FR.glossary,
        sentences: FR.sentences,
        validation: FR.validation,
      },
    },
  });

dayjs.locale(i18n.language);

export default i18n;

let isTogglingLanguage = false;

export const toggleLanguage = () => {
  if (isTogglingLanguage) return;
  isTogglingLanguage = true;

  const nextLanguage =
    i18n.language != null && i18n.language.includes('fr') ? 'en' : 'fr';

  dayjs.locale(nextLanguage);
  void i18n.changeLanguage(nextLanguage).finally(() => {
    isTogglingLanguage = false;
  });
};

export const setAppLanguage = (language) => {
  if (language !== 'en' && language !== 'fr') return Promise.resolve();
  if (isTogglingLanguage) return Promise.resolve();
  const current =
    i18n.language != null && i18n.language.includes('fr') ? 'fr' : 'en';
  if (language === current) return Promise.resolve();

  isTogglingLanguage = true;
  dayjs.locale(language);
  return i18n.changeLanguage(language).finally(() => {
    isTogglingLanguage = false;
  });
};

export const getAppLanguage = () =>
  i18n.language != null && i18n.language.includes('fr') ? 'fr' : 'en';

export const toTitleCase = phrase => {
  return phrase
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const toFamilyCase = phrase => {
  return phrase
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join('-');
};

/** Capitalize only the first character of the string (e.g. for team names). */
export const capitalizeFirst = str =>
  str && str.length ? str.charAt(0).toUpperCase() + str.slice(1) : str || '';
